import React, { forwardRef, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Snackbar,
  Typography,
} from '@material-ui/core';

import { ERROR_MESSAGE } from '../../../constant';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const TransitionRight = forwardRef(function TransitionRight(props, ref) {
  return <Slide {...props} direction="right" ref={ref} />;
});

export function AlertErrorComponent({ message, handleClose }) {
  const errorMessage = message;
  const [snackOpen, setSnackOpen] = useState(true);

  /**
   * for closing alert message
   * @function handleSnackClose
   */
  const handleSnackClose = () => {
    setSnackOpen(false);
    if (handleClose) handleClose(false);
  };

  useEffect(() => {
    setSnackOpen(true);
  }, [errorMessage]);

  // render ui component
  return (
    <Snackbar
      open={snackOpen}
      autoHideDuration={5000}
      onClose={handleSnackClose}
      TransitionComponent={TransitionRight}
      sx={{ maxWidth: 450 }}
    >
      <Alert onClose={handleSnackClose} severity="error" data-testid="alert-error">
        <Typography className="alert-error-message">{errorMessage || ERROR_MESSAGE}</Typography>
      </Alert>
    </Snackbar>
  );
}
